import React from 'react';
import { Languages } from 'lucide-react';

const LanguageSwitcher = ({ setLang, currentLang }) => {
  const languages = [
    { code: 'en', label: 'EN', full: 'English' },
    { code: 'bn', label: 'বাং', full: 'বাংলা' },
    { code: 'hi', label: 'हिं', full: 'हिंदी' }
  ];

  return (
    <div className="flex items-center bg-white/10 backdrop-blur-md p-1 rounded-xl border border-white/20 shadow-inner">
      <div className="hidden sm:block px-2 text-gold">
        <Languages size={16} />
      </div>
      
      <div className="flex space-x-1">
        {languages.map((l) => (
          <button
            key={l.code}
            onClick={() => setLang(l.code)}
            className={`
              relative px-3 py-1.5 rounded-lg text-[10px] font-black tracking-tighter transition-all duration-300 transform active:scale-90
              ${currentLang === l.code 
                ? 'bg-gradient-to-b from-orange to-gold text-navy shadow-lg scale-105' 
                : 'text-gray-300 hover:text-white hover:bg-white/5'}
            `}
          >
            <span className="relative z-10">{l.label}</span>
            {currentLang === l.code && (
              <span className="absolute inset-0 bg-white/20 rounded-lg animate-pulse"></span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
  return <div className="p-6 text-center">Loading...</div>;
};

export default LanguageSwitcher;